/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InitiativeControlMappingDto } from './InitiativeControlMappingDto';
import {
    InitiativeControlMappingDtoFromJSON,
    InitiativeControlMappingDtoFromJSONTyped,
    InitiativeControlMappingDtoToJSON,
    InitiativeControlMappingDtoToJSONTyped,
} from './InitiativeControlMappingDto';
import type { InitiativeMilestoneDto } from './InitiativeMilestoneDto';
import {
    InitiativeMilestoneDtoFromJSON,
    InitiativeMilestoneDtoFromJSONTyped,
    InitiativeMilestoneDtoToJSON,
    InitiativeMilestoneDtoToJSONTyped,
} from './InitiativeMilestoneDto';

/**
 * 
 * @export
 * @interface SecurityInitiativeDto
 */
export interface SecurityInitiativeDto {
    /**
     * 
     * @type {string}
     * @memberof SecurityInitiativeDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SecurityInitiativeDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof SecurityInitiativeDto
     */
    profileId?: string;
    /**
     * 
     * @type {string}
     * @memberof SecurityInitiativeDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SecurityInitiativeDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof SecurityInitiativeDto
     */
    intent?: string;
    /**
     * 
     * @type {string}
     * @memberof SecurityInitiativeDto
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof SecurityInitiativeDto
     */
    priorityRank?: number;
    /**
     * 
     * @type {string}
     * @memberof SecurityInitiativeDto
     */
    drivenBy?: string;
    /**
     * 
     * @type {string}
     * @memberof SecurityInitiativeDto
     */
    ownerUserId?: string;
    /**
     * 
     * @type {number}
     * @memberof SecurityInitiativeDto
     */
    budgetAllocated?: number;
    /**
     * 
     * @type {string}
     * @memberof SecurityInitiativeDto
     */
    budgetCurrency?: string;
    /**
     * 
     * @type {Date}
     * @memberof SecurityInitiativeDto
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SecurityInitiativeDto
     */
    targetDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SecurityInitiativeDto
     */
    completedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof SecurityInitiativeDto
     */
    clonedFromId?: string;
    /**
     * 
     * @type {string}
     * @memberof SecurityInitiativeDto
     */
    mandatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof SecurityInitiativeDto
     */
    mandateNote?: string;
    /**
     * 
     * @type {Date}
     * @memberof SecurityInitiativeDto
     */
    riskAcceptedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof SecurityInitiativeDto
     */
    riskAcceptedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof SecurityInitiativeDto
     */
    riskAcceptanceNote?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SecurityInitiativeDto
     */
    aiGenerated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SecurityInitiativeDto
     */
    aiModelVersion?: string;
    /**
     * 
     * @type {Date}
     * @memberof SecurityInitiativeDto
     */
    humanReviewedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof SecurityInitiativeDto
     */
    capabilityDomain?: string;
    /**
     * 
     * @type {number}
     * @memberof SecurityInitiativeDto
     */
    targetMaturity?: number;
    /**
     * 
     * @type {string}
     * @memberof SecurityInitiativeDto
     */
    lifecyclePhase?: string;
    /**
     * 
     * @type {number}
     * @memberof SecurityInitiativeDto
     */
    version?: number;
    /**
     * 
     * @type {Date}
     * @memberof SecurityInitiativeDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SecurityInitiativeDto
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof SecurityInitiativeDto
     */
    createdBy?: string;
    /**
     * 
     * @type {Array<InitiativeMilestoneDto>}
     * @memberof SecurityInitiativeDto
     */
    milestones?: Array<InitiativeMilestoneDto>;
    /**
     * 
     * @type {Array<InitiativeControlMappingDto>}
     * @memberof SecurityInitiativeDto
     */
    controlMappings?: Array<InitiativeControlMappingDto>;
    /**
     * 
     * @type {number}
     * @memberof SecurityInitiativeDto
     */
    activePlanCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SecurityInitiativeDto
     */
    completedTaskCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SecurityInitiativeDto
     */
    totalTaskCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SecurityInitiativeDto
     */
    budgetSpent?: number;
    /**
     * 
     * @type {number}
     * @memberof SecurityInitiativeDto
     */
    cardMaturityCurrentAvg?: number;
    /**
     * 
     * @type {number}
     * @memberof SecurityInitiativeDto
     */
    cardMaturityTargetAvg?: number;
    /**
     * 
     * @type {string}
     * @memberof SecurityInitiativeDto
     */
    cardMaturityFocusLabel?: string;
}

/**
 * Check if a given object implements the SecurityInitiativeDto interface.
 */
export function instanceOfSecurityInitiativeDto(value: object): value is SecurityInitiativeDto {
    return true;
}

export function SecurityInitiativeDtoFromJSON(json: any): SecurityInitiativeDto {
    return SecurityInitiativeDtoFromJSONTyped(json, false);
}

export function SecurityInitiativeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecurityInitiativeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'profileId': json['profileId'] == null ? undefined : json['profileId'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'intent': json['intent'] == null ? undefined : json['intent'],
        'status': json['status'] == null ? undefined : json['status'],
        'priorityRank': json['priorityRank'] == null ? undefined : json['priorityRank'],
        'drivenBy': json['drivenBy'] == null ? undefined : json['drivenBy'],
        'ownerUserId': json['ownerUserId'] == null ? undefined : json['ownerUserId'],
        'budgetAllocated': json['budgetAllocated'] == null ? undefined : json['budgetAllocated'],
        'budgetCurrency': json['budgetCurrency'] == null ? undefined : json['budgetCurrency'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'targetDate': json['targetDate'] == null ? undefined : (new Date(json['targetDate'])),
        'completedAt': json['completedAt'] == null ? undefined : (new Date(json['completedAt'])),
        'clonedFromId': json['clonedFromId'] == null ? undefined : json['clonedFromId'],
        'mandatedBy': json['mandatedBy'] == null ? undefined : json['mandatedBy'],
        'mandateNote': json['mandateNote'] == null ? undefined : json['mandateNote'],
        'riskAcceptedAt': json['riskAcceptedAt'] == null ? undefined : (new Date(json['riskAcceptedAt'])),
        'riskAcceptedBy': json['riskAcceptedBy'] == null ? undefined : json['riskAcceptedBy'],
        'riskAcceptanceNote': json['riskAcceptanceNote'] == null ? undefined : json['riskAcceptanceNote'],
        'aiGenerated': json['aiGenerated'] == null ? undefined : json['aiGenerated'],
        'aiModelVersion': json['aiModelVersion'] == null ? undefined : json['aiModelVersion'],
        'humanReviewedAt': json['humanReviewedAt'] == null ? undefined : (new Date(json['humanReviewedAt'])),
        'capabilityDomain': json['capabilityDomain'] == null ? undefined : json['capabilityDomain'],
        'targetMaturity': json['targetMaturity'] == null ? undefined : json['targetMaturity'],
        'lifecyclePhase': json['lifecyclePhase'] == null ? undefined : json['lifecyclePhase'],
        'version': json['version'] == null ? undefined : json['version'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'milestones': json['milestones'] == null ? undefined : ((json['milestones'] as Array<any>).map(InitiativeMilestoneDtoFromJSON)),
        'controlMappings': json['controlMappings'] == null ? undefined : ((json['controlMappings'] as Array<any>).map(InitiativeControlMappingDtoFromJSON)),
        'activePlanCount': json['activePlanCount'] == null ? undefined : json['activePlanCount'],
        'completedTaskCount': json['completedTaskCount'] == null ? undefined : json['completedTaskCount'],
        'totalTaskCount': json['totalTaskCount'] == null ? undefined : json['totalTaskCount'],
        'budgetSpent': json['budgetSpent'] == null ? undefined : json['budgetSpent'],
        'cardMaturityCurrentAvg': json['cardMaturityCurrentAvg'] == null ? undefined : json['cardMaturityCurrentAvg'],
        'cardMaturityTargetAvg': json['cardMaturityTargetAvg'] == null ? undefined : json['cardMaturityTargetAvg'],
        'cardMaturityFocusLabel': json['cardMaturityFocusLabel'] == null ? undefined : json['cardMaturityFocusLabel'],
    };
}

export function SecurityInitiativeDtoToJSON(json: any): SecurityInitiativeDto {
    return SecurityInitiativeDtoToJSONTyped(json, false);
}

export function SecurityInitiativeDtoToJSONTyped(value?: SecurityInitiativeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'profileId': value['profileId'],
        'name': value['name'],
        'description': value['description'],
        'intent': value['intent'],
        'status': value['status'],
        'priorityRank': value['priorityRank'],
        'drivenBy': value['drivenBy'],
        'ownerUserId': value['ownerUserId'],
        'budgetAllocated': value['budgetAllocated'],
        'budgetCurrency': value['budgetCurrency'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString().substring(0,10)),
        'targetDate': value['targetDate'] == null ? undefined : ((value['targetDate']).toISOString().substring(0,10)),
        'completedAt': value['completedAt'] == null ? undefined : ((value['completedAt']).toISOString()),
        'clonedFromId': value['clonedFromId'],
        'mandatedBy': value['mandatedBy'],
        'mandateNote': value['mandateNote'],
        'riskAcceptedAt': value['riskAcceptedAt'] == null ? undefined : ((value['riskAcceptedAt']).toISOString()),
        'riskAcceptedBy': value['riskAcceptedBy'],
        'riskAcceptanceNote': value['riskAcceptanceNote'],
        'aiGenerated': value['aiGenerated'],
        'aiModelVersion': value['aiModelVersion'],
        'humanReviewedAt': value['humanReviewedAt'] == null ? undefined : ((value['humanReviewedAt']).toISOString()),
        'capabilityDomain': value['capabilityDomain'],
        'targetMaturity': value['targetMaturity'],
        'lifecyclePhase': value['lifecyclePhase'],
        'version': value['version'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'createdBy': value['createdBy'],
        'milestones': value['milestones'] == null ? undefined : ((value['milestones'] as Array<any>).map(InitiativeMilestoneDtoToJSON)),
        'controlMappings': value['controlMappings'] == null ? undefined : ((value['controlMappings'] as Array<any>).map(InitiativeControlMappingDtoToJSON)),
        'activePlanCount': value['activePlanCount'],
        'completedTaskCount': value['completedTaskCount'],
        'totalTaskCount': value['totalTaskCount'],
        'budgetSpent': value['budgetSpent'],
        'cardMaturityCurrentAvg': value['cardMaturityCurrentAvg'],
        'cardMaturityTargetAvg': value['cardMaturityTargetAvg'],
        'cardMaturityFocusLabel': value['cardMaturityFocusLabel'],
    };
}

